// @flow
import OrdersTable from './OrdersTable';
import connect from './connect';

export default connect(OrdersTable);



// WEBPACK FOOTER //
// ./src/components/OrdersTable/index.js